module.exports = __webpack_public_path__ + "457d1e13175bcfba65da0197490c3170.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-banner-redshoes.svg
// module id = 470
// module chunks = 0